import interceptors from '@/api/interceptors';
import { client } from '@/api/client';
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getReturDelivery(params) {
	return client.get("api/pdor/data", {
		params: params,
	});
}

function getStatusRD() {
	return client.get("api/options/retur-delivery-status");
}

function getRDforReceive() {
	return client.get("api/options/retur-delivery-for-receive");
}

function exportReturDelivery(params) {
	return client.get("api/pdor/export", {
		params: params,
	});
}

function detailReturDelivery(params) {
	return client.get("api/pdor/detail", {
		params: {
			pdor_code : params
		},
	});
}

function receiveReturDelivery (params) {
	return client.post("api/pdor/receive", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getReturDelivery,
	getStatusRD,
	getRDforReceive,
	exportReturDelivery,
	detailReturDelivery,
	receiveReturDelivery,
};